module.exports = __webpack_public_path__ + "img/WP2023-CPC-montage.987ff1db.jpg";